module.exports = "/dist/roboto-latin-500.svg?f1d811cdfaea49c969500d4bbe52251b";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500.svg
// module id = 90
// module chunks = 0